<div class="dropdown">
    <a href="#"class="nav-link dropdown-toggle"  href="#" role="button"  data-bs-toggle="dropdown" aria-expanded="false" id="dropdownMenuUserManagement">

      <div class="d-none d-md-block"> <i class='fa fa-bullseye'></i></div>
        <i class='fa fa-bullseye d-md-none'></i>
      User Manager <span class="caret"></span></a>


  <div class="dropdown-menu" role="menu"  aria-labelledby="dropdownMenuUserManagement">
    <a [routerLink]="['/admin/user/index']" tabindex="-1" class="nav-link dropdown-item"><i class="fa fa-users"></i> Users</a>
    <a [routerLink]="['/admin/rg/index']" tabindex="-1" class="nav-link dropdown-item"><i class="fa fa-list"></i> Groups</a>
    <a [routerLink]="['/admin/permission/index',0]" tabindex="-1" class="nav-link dropdown-item"><i class="fa fa-plus"></i> Permissions</a>
  </div>
</div>
